<template>
  <v-container fluid>
    <dps-subheader @on-dates-selected="updateAvailabilitiesDates" :is-loading="isLoading"></dps-subheader>

    <v-layout row class="mt-4">
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-container class="panel" v-if="parking !== null">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-layout row wrap class="panel-heading">
                    <v-flex xs12>
                      <template v-if="parking.isUpdatingAvailabilities && updatingAvailabilitiesMessage">
                        <v-alert :value="true" color="info" icon="new_releases">
                          <v-progress-circular indeterminate color="red"></v-progress-circular>
                          {{
                            $t('global.availabilities.updating.legend', {
                              startDate: this.updateAvailabilitiesStartDate,
                              endDate: this.updateAvailabilitiesEndDate,
                              fromDate: this.updateAvailabilitiesDate
                            })
                          }}
                        </v-alert>
                      </template>
                    </v-flex>
                    <v-flex xs10 d-flex>
                      <h2 class="panel-title">
                        <b>
                          <span v-html="$t('private_availabilities_title')"></span>
                        </b>
                      </h2>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex text-xs-right>
                      <v-btn
                        icon
                        plain
                        @click.prevent="isAvailabilityDialogVisible = true"
                        :disabled="parking.isUpdatingAvailabilities"
                      >
                        <v-icon
                          color="primary"
                          :disabled="parking.isUpdatingAvailabilities"
                          >mdi-pencil</v-icon>
                      </v-btn>
                      <!-- Popover con la lista -->
                      <v-menu v-model="menu" offset-y left :close-on-content-click="false"  v-if="parking.type === 'SENSORED'">
                        <v-btn
                          icon
                          plain
                          slot="activator"
                        >
                          <v-icon color="primary"
                            >mdi-filter</v-icon
                          >
                        </v-btn>

                        <v-card class="popoverCard">
                          <!-- Buscador -->
                          <v-text-field
                            v-model="search"
                            :label="$t('availability_graph_filter_spots_label')"
                            clearable
                            dense
                            :hide-details="true"
                            class="ml-4 mr-4"
                          />

                          <!-- Checkboxes Seleccionar Todo / Deseleccionar Todo -->
                          <v-layout row class="ml-4 mr-4">
                            <v-checkbox
                              v-model="allSelected"
                              :indeterminate="indeterminate"
                              :label="$t('availability_graph_filter_spots_all')"
                              @change="toggleSelectAll"
                              :hide-details="true"
                              color="info"
                            />
                          </v-layout>

                          <!-- Lista de elementos con Checkboxes -->
                          <v-list dense class="popoverList pt-0 mt-3">
                            <v-list-tile
                              v-for="(item) in filteredItems"
                              :key="item.id"
                              class="ml-2 mr-2 pa-0"
                            >
                              <v-list-tile-content>
                                <v-checkbox
                                  v-model="selectedItems"
                                  :value="item"
                                  :label="item.label"
                                  color="info"
                                />
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-list>
                        </v-card>
                      </v-menu>
                      <v-menu offset-y>
                        <v-btn
                          icon
                          plain
                          slot="activator"
                        >
                          <v-icon color="primary"
                            >mdi-dots-vertical</v-icon
                          >
                        </v-btn>
                        <v-list>
                          <v-list-tile @click="generalView = true">
                            <v-list-tile-title>{{ $t('view_general_graph') }}</v-list-tile-title>
                          </v-list-tile>
                          <v-list-tile @click="generalView = false">
                            <v-list-tile-title>{{ $t('view_detailed_graph') }}</v-list-tile-title>
                          </v-list-tile>
                        </v-list>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 mt-2 v-loading="isLoading" style="min-height: 150px">
                  <parking-availability-sensor-graph
                    v-if="parking.type === 'SENSORED'"
                    :dates="dates"
                    :graph-data="filteredGraphData"
                    :parking-id="parkingId"
                    :is-availability-dialog-visible="showOpenModalAvailabilitiesAutomatic"
                    :general-view="generalView"
                    @on-close-modal="closeModal"
                    @on-refresh-graphs="updateAvailabilities"
                  ></parking-availability-sensor-graph>
                  <parking-availability-sensorless-graph
                    v-else
                    :graph-data="graphData"
                    :dates="dates"
                    :parking-id="parkingId"
                    :is-availability-dialog-visible="showOpenModalAvailabilitiesAutomatic"
                    :general-view="generalView"
                    @on-close-modal="closeModal"
                    @on-refresh-graphs="updateAvailabilities"
                  ></parking-availability-sensorless-graph>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Subheader from '@/components/commons/Subheader.vue';
import FromDateSelector from '@/components/commons/FromToDateSelector.vue';
import ParkingAvailabilitySensorGraph from '@/components/commons/ParkingAvailabilitySensorGraph.vue';
import ParkingAvailabilitySensorlessGraph from '@/components/commons/ParkingAvailabilitySensorlessGraph.vue';
import availabilityService from '@/services/availabilityService';
import spotService from '@/services/spotService';
import parkingService from '@/services/parkingService';
import store from '@/store/index';
import keys from '@/store/keys';
import _ from 'lodash';
import moment from 'moment';
import { EventBus } from '@/services/eventBus';

export default {
  name: 'ParkingAvailability',
  components: {
    [FromDateSelector.name]: FromDateSelector,
    [Subheader.name]: Subheader,
    [ParkingAvailabilitySensorGraph.name]: ParkingAvailabilitySensorGraph,
    [ParkingAvailabilitySensorlessGraph.name]: ParkingAvailabilitySensorlessGraph
  },
  computed: {
    updateAvailabilitiesStartDate() {
      return this.$options.filters.formatDate(this.updatingAvailabilitiesMessage.startDate);
    },
    updateAvailabilitiesEndDate() {
      return this.$options.filters.formatDate(this.updatingAvailabilitiesMessage.endDate);
    },
    updateAvailabilitiesDate() {
      return this.$options.filters.formatDate(this.updatingAvailabilitiesMessage.fromDate);
    },
    showOpenModalAvailabilitiesAutomatic() {
      return this.isAvailabilityDialogVisible && !this.parking.isUpdatingAvailabilities;
    },
    filteredGraphData() {
      let graphDataFiltered = [];
      if (this.graphData) {
        let futureReservations = 0;
        let futureSubscriptions = 0;
        let reservationsInUse = 0;
        let reservationsPaid = 0;
        let subscriptionsInUse = 0;
        let subscriptionsPaid = 0;
        graphDataFiltered.chartData = this.graphData.chartData.filter((plot) => {
          let found = false;
          _.each(this.selectedItems, (spot, key) => {
            if (spot.id === plot.spotId) {
              futureReservations += plot.totalAccepted;
              futureSubscriptions += plot.totalAcceptedSubscription;
              reservationsInUse += plot.totalInUse;
              reservationsPaid += plot.totalPaid;
              subscriptionsInUse += plot.totalInUseSubscription;
              subscriptionsPaid += plot.totalPaidSubscription;
              found = true;
            }
          });
          return found
        });
        graphDataFiltered.chartSettings = this.graphData.chartSettings;
        graphDataFiltered.chartSettings.spots = this.selectedItems.length;
        graphDataFiltered.chartSettings.statusStats = {
          countFutureReservations: futureReservations,
          countFutureSubscriptions: futureSubscriptions,
          countReservationsInUse: reservationsInUse,
          countReservationsPaid: reservationsPaid,
          countSubscriptionsInUse: subscriptionsInUse,
          countSubscriptionsPaid: subscriptionsPaid
        }
      }
      return graphDataFiltered;
    },
    // Filtra los elementos basados en la búsqueda
    filteredItems() {
      if (!this.search) {
        return this.spots;
      } else {
        return this.spots.filter(spot =>
          spot.label.toLowerCase().includes(this.search.toLowerCase())
        );
      }
    },
    // Determina si todos los elementos están seleccionados
    allSelected: {
      get() { return this.selectedItems.length === this.filteredItems.length && this.filteredItems.length > 0; },
      set(newValue) { }
    },
    // Determina si hay una selección parcial
    indeterminate() {
      return this.selectedItems.length > 0 && this.selectedItems.length < this.filteredItems.length;
    }
  },
  data() {
    return {
      isAvailabilityDialogVisible: this.$route.params.isAvailabilityDialogVisible,
      parkingId: this.$route.params.id,
      dates: [],
      parking: null,
      graphData: null,
      spots: [],
      isLoading: true,
      generalView: true,
      updatingAvailabilitiesMessage: {
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        fromDate: moment().format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD')
      },
      cancelTimeout: false,
      spotsReady: false,
      menu: false, // Controla la visibilidad del popover
      search: '', // Cadena de búsqueda
      selectedItems: [] // Elementos seleccionados
    };
  },
  created() {
    this.cancelTimeout = false;
    if (store.state.parkingSelected !== null && this.parkingId === store.state.parkingSelected.id) {
      this.parking = store.state.parkingSelected;
    }
    EventBus.$on(keys.eventOnLanguageChanged, this.updateGraphLanguage);
    EventBus.$on(keys.eventOnParkingAvailabilitiesUpdated, this.timeoutValidateUpdatingAvailabilities);

    this.dates = [
      moment()
        .startOf('month')
        .toDate(),
      moment()
        .endOf('month')
        .toDate()
    ];
    this.loadSpots();
  },
  destroyed() {
    EventBus.$off(keys.eventOnLanguageChanged, this.updateGraphLanguage);
    EventBus.$off(keys.eventOnParkingAvailabilitiesUpdated, this.timeoutValidateUpdatingAvailabilities);
    this.cancelTimeout = true;
  },
  methods: {
    // Alterna la selección de todos los elementos
    toggleSelectAll() {
      if (this.allSelected) {
        this.selectedItems = [];
      } else {
        this.selectedItems = [...this.filteredItems];
      }
    },
    loadSpots() {
      let params = {
        parking: this.parkingId
      };
      if (this.parking === null) {
        parkingService.summary(params, this.summarySuccessHandler, this.summaryErrorHandler);
      } else {
        spotService.list(params, this.spotListSuccessHandler, this.spotListErrorSuccessHander);
      }
    },
    summarySuccessHandler(data) {
      this.parking = data;
      if (typeof this.parking.contacts === 'undefined') {
        this.parking.contacts = [];
      }
      store.commit('UPDATE_PARKING_SELECTED', this.parking);

      let params = {
        parking: this.parkingId
      };

      spotService.list(params, this.spotListSuccessHandler, this.spotListErrorSuccessHander);
    },
    summaryErrorHandler(error) {
      if (error.status === 404) {
        EventBus.$emit(keys.eventOnShowNotification, {
          title: '',
          message: 'error_404',
          type: 'error'
        });
      }

      this.$router.push({ name: 'Dashboard' });
    },
    timeoutValidateUpdatingAvailabilities() {
      let params = { parking: this.parkingId };
      availabilityService.isParkingUpdatingAvailabilities(params, this.isParkingUpdatingAvailabilitiesSuccessHandler, this.isParkingUpdatingAvailabilitiesErrorHandler);
    },
    isParkingUpdatingAvailabilitiesSuccessHandler(data) {
      if (data.isUpdatingAvailabilities === true) {
        let cloneParking = _.cloneDeep(this.parking);
        cloneParking.isUpdatingAvailabilities = true;
        cloneParking.updatingAvailabilitiesLegend = data.updatingAvailabilitiesLegend;
        store.commit('UPDATE_PARKING_SELECTED', cloneParking);
        this.parking = store.state.parkingSelected;
        this.updatingAvailabilitiesMessage = JSON.parse(data.updatingAvailabilitiesLegend);

        if (!this.cancelTimeout) {
          setTimeout(() => {
            this.timeoutValidateUpdatingAvailabilities();
          }, 5000);
        }
        return;
      } else {
        EventBus.$emit(keys.eventOnShowNotification, {
          title: '',
          message: 'private_availabilities_edit_success_message_with_parking',
          type: 'success',
          messageParams: { parkingName: this.parking.name }
        });

        this.updateAvailabilities();
      }
      let cloneParking = _.cloneDeep(this.parking);
      cloneParking.isUpdatingAvailabilities = false;
      cloneParking.updatingAvailabilitiesLegend = '';
      store.commit('UPDATE_PARKING_SELECTED', cloneParking);
      this.parking = store.state.parkingSelected;
    },
    isParkingUpdatingAvailabilitiesErrorHandler() {},
    spotListSuccessHandler(data) {
      let cloneParking = _.cloneDeep(this.parking);
      if (cloneParking === null) {
        return;
      }
      if (data.spots) {
        this.spots = data.spots;
        this.selectedItems = data.spots;
        cloneParking.hasSensors = true;
        this.spots = _.sortBy(this.spots, itSpot => itSpot.label);

        store.commit('UPDATE_PARKING_SELECTED', cloneParking);
        store.commit('UPDATE_PARKING_SPOTS', this.spots);
      } else {
        cloneParking.hasSensors = false;
        store.commit('UPDATE_PARKING_SPOTS_TOTAL', data.total);
      }

      this.spotsReady = true;

      if (this.parking.isUpdatingAvailabilities) {
        this.timeoutValidateUpdatingAvailabilities();
      }
    },
    spotListErrorSuccessHander() {},
    updateAvailabilitiesDates(params) {
      this.dates = _.clone(params.dates);
      this.updateAvailabilities();
    },
    updateAvailabilities() {
      if (!this.spotsReady) {
        setTimeout(() => {
          this.updateAvailabilities();
        }, 2000);
        return;
      }

      if (!this.isAvailabilityDialogVisible) {
        this.isLoading = true;
      }
      let paramsDates = {
        parking: this.parkingId,
        start: moment(this.dates[0]).format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
        end: moment(this.dates[1]).format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
        isSummary: false,
        withReservations: true
      };
      availabilityService.list(paramsDates, this.listSuccessHandler, this.listErrorSuccessHander);
    },

    listSuccessHandler(data) {
      this.graphData = data;
      this.isLoading = false;
    },
    listErrorSuccessHander(data) {
      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: data.message,
        type: 'error',
        doNotTranslate: true
      });
    },
    updateGraphLanguage() {
      let temp = this.graphData;
      this.graphData = null;
      this.$nextTick(() => {
        this.graphData = temp;
      });
    },
    closeModal() {
      this.isAvailabilityDialogVisible = false;
    }
  }
};
</script>

<style scoped>
.popoverCard {
  overflow-y: auto;  /* Habilitar desplazamiento vertical si el contenido excede la altura */
}

.popoverList {
  max-height: 250px; /* Ajuste para que el buscador y los botones tengan espacio */
  overflow-y: auto;
}

.v-btn--icon {
  margin: 0px !important;
}

.v-list__tile {
  padding: 0px !important;
}
</style>




// WEBPACK FOOTER //
// src/components/parking/Availability.vue